import { Routes, Route, Navigate } from 'react-router-dom';
import { SignedIn, SignedOut, SignIn } from '@clerk/clerk-react';
import ProtectedLayout from './components/ProtectedLayout';
import { useMe } from './lib/me';
import Overview from './pages/Overview';
import Upload from './pages/Upload';
import Mapping from './pages/Mapping';
import Adjustments from './pages/Adjustments';
import Outputs from './pages/Outputs';

function RoutedPages() {
  const me = useMe();
  // Rowcal uploaders only ever see the upload page.
  if (me.data?.role === 'uploader') {
    return (
      <Routes>
        <Route path="/upload" element={<Upload />} />
        <Route path="*" element={<Navigate to="/upload" replace />} />
      </Routes>
    );
  }
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/overview" replace />} />
      <Route path="/overview" element={<Overview />} />
      <Route path="/upload" element={<Upload />} />
      <Route path="/mapping" element={<Mapping />} />
      <Route path="/adjustments" element={<Adjustments />} />
      <Route path="/outputs" element={<Outputs />} />
      <Route path="*" element={<Navigate to="/overview" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <>
      <SignedIn>
        <ProtectedLayout>
          <RoutedPages />
        </ProtectedLayout>
      </SignedIn>
      <SignedOut>
        {/* Embedded (not Clerk's hosted page) so this app's sign-in copy applies. */}
        <div className="flex min-h-screen items-center justify-center bg-slate-50">
          <SignIn routing="hash" />
        </div>
      </SignedOut>
    </>
  );
}
